import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { SubscribeForm } from 'forms';
import { useHubspotForm } from 'hooks';

import './SubscribeNewsletter.scss';

export interface SubscribeNewsletterProps {
    /**
     * Class name styles
     */
    className?: string;
    /**
     * Style
     */
    style?: any;
    /**
     * Function called after form submit
     */
    onAfterSubmit?(form): any;
}

const SubscribeNewsletter: React.FC<SubscribeNewsletterProps> = ({ className, style, onAfterSubmit = () => {} }) => {
    const { t } = useTranslation();
    const { loading, onSubmit } = useHubspotForm({ analytics: { data_traffic_origin: 'Web_Blog' }, t, onSuccess: onAfterSubmit });
    const classNames = classnames(['subscribeNewsletter', className]);

    const handleSubmit = (form: any) => {
        onSubmit(form);
    };

    return (
        <div className={classNames} style={style}>
            <SubscribeForm loading={loading} onSubmit={handleSubmit} t={t} />
        </div>
    );
};

export default SubscribeNewsletter;
